import React, { useEffect, useMemo, useRef, useState } from "react";
import PageTable from "@/components/i-pageTable/i-pageTable";
import PageTab from "@/components/i-pageTab/i-pageTab";

import {
  shoppingOrderList,
  shoppingOrderExport,
  getRewardDetail,
  getDeviceCount,
} from "@/api/shopping";
import { storeInfoBaseList } from "@/api/index";

import { Button, message, Modal, Space, Tag, Image } from "antd";
import {
  downloadFile,
  getFirstDay,
  getTimeFormat,
  resetForm,
  setIcons,
} from "@/utils/common";

import { useSelector, useDispatch, useStore } from "react-redux";
import { dictInfoAsync } from "@/stores/dictInfo";
import IForm from "@/components/i-form/i-form";
import { rewardDetailColumns, payDetailColumns, formTab } from "./helps";
import { shopType } from '@/pages/equipment/hepls'

const notRefund = ["10007012", "10007011", "10007014", "10007016", "10007008"];

const OrderManager = () => {
  const dispatch = useDispatch();
  const {
    state: { goods_order_status, express_status, express_company_code },
  } = useSelector((state: { dictInfo: any }) => state.dictInfo);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [sendGoodsOpen, setSendGoodsOpen] = useState(false);
  const [deviceCount, setDeviceCount] = useState(0);
  const [offqybOpen, setOffqybOpen] = useState(false);
  const [payDetailOpen, setPayDetailOpen] = useState(false);
  const [payDetailList, setPayDetailList] = useState<any[]>([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [rewardDetailData, setRewardDetailData] = useState<any>({
    rows: [],
    total: 0,
  });


  const [pageData, setPageData] = useState<
    SelectCmsShoppingOrderPageRes["rows"]
  >([]);
  const [formData, setFormData] = useState<any>({
    categoryName: "",
    startTime: getTimeFormat(getFirstDay(new Date()), "yyyy-MM-dd HH:mm:ss"),
    endTime: getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss"),
    ypageNum: 1,
    ypageSize: 10,
  });

  const [rewardDetailFormData, setRewardDetailFormData] = useState<any>({
    ypageNum: 1,
    ypageSize: 10,
    businessId: "",
  });

  const getDeviceCountData = async () => {
    const res = await getDeviceCount({
      ...formData,
    });
    setDeviceCount(res.data);
  };

  const footer = [
    {
      title: "导出",
      icon: setIcons("DownloadOutlined"),
      onClick: () => exportExcel(),
      loading: exportLoading,
    },
    {
      render: (
        <div style={{ lineHeight: "32px" }}>
          <div>总设备数量：{deviceCount}</div>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "订单号",
      dataIndex: "orderId",
      key: "orderId",
      // width: "220px",
    },
    {
      title: "用户Id",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "用户昵称",
      dataIndex: "nickName",
      key: "nickName",
    },
  
    {
      title: "用户账号",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "团队属性",
      dataIndex: "teamAttribute",
      key: "teamAttribute",
    },

    {
      title: "产品名称",
      dataIndex: "productName",
      key: "productName",
      width: "200px",
    },
    {
      title: "购买数量",
      dataIndex: "num",
      key: "num",
    },
    {
      title: "设备数量",
      dataIndex: "deviceNum",
      key: "deviceNum",
    },

    {
      title: "订单原价",
      dataIndex: "productTotalPrice",
      key: "productTotalPrice",
    },
    {
      title: "实付金额",
      dataIndex: "payPrice",
      key: "payPrice",
    },  {
      title: "手续费",
      dataIndex: "serviceCharge",
      key: "serviceCharge",
    },
    {
      title: "订单状态",
      dataIndex: "orderStatus",
      key: "orderStatus",
      render: (val: string) => (
        <Tag color="green">{val == "0" ? "已支付" : "未支付"}</Tag>
      ),
    },
    {
      title: "是否分佣",
      dataIndex: "hasRewardStr",
      key: "hasRewardStr",
      render: (val: string) => (
        <Tag color={val == "是" ? "green" : "red"}>{val}</Tag>
      ),
    },
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: "createTime",
    },
    {
      title: "操作",
      dataIndex: "orderId",
      key: "orderId",
      fixed: "right",
      render: (val: string, rows: any) => (
        <Space size="small">
          <Button
            size="small"
            icon={setIcons("DollarOutlined")}
            type="text"
            onClick={() => {
              setOrderDollar(val);
            }}
          >
            分润详情
          </Button>
          <Button
            size="small"
            icon={setIcons("PayCircleOutlined")}
            type="text"
            onClick={() => {
              setPayDetailList(rows?.mallOrderPayVOList ?? []);
              setPayDetailOpen(true);
            }}
          >
            支付详情
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getPageData();
    getDeviceCountData();
  }, [formData]);

  useEffect(() => {
    !goods_order_status && dispatch(dictInfoAsync("goods_order_status") as any);
    !express_status && dispatch(dictInfoAsync("express_status") as any);
    !express_company_code &&
      dispatch(dictInfoAsync("express_company_code") as any);
  }, []);

  useEffect(() => {
    if (rewardDetailFormData.businessId) {
      getModalData();
    }
  }, [rewardDetailFormData]);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await shoppingOrderList(formData);
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({ ...formData, ...val, ypageNum: 1 });
  };
  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  const exportExcel = async () => {
    setExportLoading(true);
    try {
      const data = await shoppingOrderExport(formData);
      downloadFile(
        data as any,
        "销售订单导出" + getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss")
      );
    } catch (error) {
    } finally {
      setExportLoading(false);
    }
  };

  const setOrderDollar = async (val: string) => {
    setRewardDetailFormData({
      ...rewardDetailFormData,
      businessId: val,
      businessOrderType: "1",
    });
    setOffqybOpen(true);
  };

  const getModalData = async () => {
    try {
      const data: any = await getRewardDetail(rewardDetailFormData);
      setRewardDetailData({
        rows: data.rows,
        total: data.total,
      });
    } catch (error) {}
  };

  const reset = () => {
    setFormData({
      ...resetForm(formData),
      dateType: 0,
      startTime: getTimeFormat(getFirstDay(new Date()), "yyyy-MM-dd HH:mm:ss"),
      endTime: getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss"),
    });
  };

  const rewardDetailClose = () => {
    setRewardDetailFormData({
      ...resetForm(rewardDetailFormData),
      ypageNum: 1,
      ypageSize: 10,
    });
    setRewardDetailData({
      rows: [],
      total: 0,
    });
    setOffqybOpen(false);
  };

  return (
    <div>
      <Modal
        title="支付详情"
        open={payDetailOpen}
        onCancel={() => setPayDetailOpen(false)}
        footer={null}
        width={720}
      >
        <PageTable
          rowKey="id"
          columns={payDetailColumns}
          data={payDetailList}

        />
      </Modal>
      <Modal
        destroyOnHidden
        open={offqybOpen}
        title="分润详情"
        width="980px"
        footer={<></>}
        onCancel={rewardDetailClose}
      >
        <PageTable
          data={rewardDetailData.rows}
          columns={rewardDetailColumns}
          pagination={{
            total: rewardDetailData.total,
            current: rewardDetailFormData.ypageNum,
            showQuickJumper: false,
          }}
          height="520px"
          pageChange={(current, pageSize) => {
            setRewardDetailFormData({
              ...rewardDetailFormData,
              ypageNum: current,
              ypageSize: pageSize,
            });
          }}
        />
      </Modal>
      <PageTab
        defaultTimer={[formData.startTime, formData.endTime]}
        reset={reset}
        search={search}
        formTab={formTab}
        footer={footer}
      ></PageTab>
      <PageTable
        loading={loading}
        rowKey="orderId"
        pageChange={pageChange}
        data={pageData}
        columns={columns}
        pagination={{
          total: total,
          current: formData.ypageNum,
        }}
      ></PageTable>
    </div>
  );
};

export default OrderManager;
